import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../../models/http-models/api-response';

/**
 * Fetches S3 pre-signed URLs from the backend.
 * Backend returns ApiResponse<string> with path as query parameter.
 */
@Injectable({
  providedIn: 'root'
})
export class MediaService {

  private readonly baseUrl = environment.apiBaseImageUrl;
  private cache = new Map<string, Observable<string | null>>();

  constructor(private http: HttpClient) { }

  getMediaUrl(path: string | null | undefined): Observable<string | null> {
    if (path == null || path === '') {
      return of(null);
    }

    if(path.startsWith('http://') || path.startsWith('https://')) {
      return of(path);
    }
    
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    if (!this.cache.has(normalizedPath)) {
      const params = new HttpParams().set('path', normalizedPath);
      const request$ = this.http
        .get<ApiResponse>(this.baseUrl, { params })
        .pipe(
          map((res) => (res?.succeeded !== false && res?.data != null ? res.data : null)),
          catchError(() => of(null)),
          shareReplay(1)
        );
      this.cache.set(normalizedPath, request$);
    }
    return this.cache.get(normalizedPath)!;
  }

  clearCache(): void {
    this.cache.clear();
  }
}
